import { TriangleAlert, TrendingUp, Timer } from "lucide-react";

function AuthResults() {
  const results = [
    {
      icon: TriangleAlert,
      value: "1 Million+",
      title: "",
      desc: "Products Successfully Authenticated by 2026",
    },
    {
      icon: TrendingUp,
      value: "99%",
      title: "",
      desc: "Counterfeit Detection Accuracy Rate",
    },
    {
      icon: Timer,
      value: "<5 Seconds",
      title: "",
      desc: "Average Product Verification Time",
    },
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-black">
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Target Goal for 2026
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Industry-leading protection backed by data
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {results.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="p-8 bg-gradient-to-br from-gray-900 to-black rounded-2xl border border-gray-800 hover:border-blue-500 transition-all duration-300 text-center group"
              >
                {/* Icon Circle */}
                <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                  <Icon className="w-8 h-8 text-white" />
                </div>

                {/* Value */}
                <div className="text-5xl font-bold bg-gradient-to-r from-blue-400 to-blue-600 bg-clip-text text-transparent mb-3">
                  {item.value}
                </div>

                {/* Title */}
                <div className="text-xl font-semibold text-white mb-2">
                  {item.title}
                </div>

                {/* Description */}
                <p className="text-gray-400">
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}

export default AuthResults;